export default "__VITE_ASSET__B$gtKTUH__"